/**
 * Ikony typov riadkov/materiálov v štýle DaexCUT (tvary), farby Tandem.
 * API kompatibilné s lucide-react: veľkosť/farba cez className,
 * stroke = currentColor.
 */
import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function base(props: IconProps): IconProps {
  return {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
    ...props,
  };
}

/** Plošný materiál — obrys dosky (DaexCUT „Materiály plošné"). */
export function IconPlosny(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="4" y="5" width="16" height="14" />
    </svg>
  );
}

/** Dĺžkový materiál — hrubá vodorovná lišta (DaexCUT „Materiály délkové"). */
export function IconDlzkovy(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="3" y="10" width="18" height="4" fill="currentColor" stroke="none" rx="1" />
    </svg>
  );
}

/** Kusový materiál / kovanie — matica (šesťhran s dierou). */
export function IconKusovy(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M12 2.5l8.2 4.75v9.5L12 21.5l-8.2-4.75v-9.5L12 2.5z" />
      <circle cx="12" cy="12" r="3.5" />
    </svg>
  );
}

/** Operácia — krúžkové šípky (DaexCUT „Operace"). */
export function IconOperacia(props: IconProps) {
  return (
    <svg {...base(props)}>
      <path d="M19.5 9.5A8 8 0 0 0 5.6 7.4" />
      <path d="M5.5 3.5v4h4" />
      <path d="M4.5 14.5a8 8 0 0 0 13.9 2.1" />
      <path d="M18.5 20.5v-4h-4" />
    </svg>
  );
}

/** Sklo — tabuľa s diagonálnym leskom. */
export function IconSklo(props: IconProps) {
  return (
    <svg {...base(props)}>
      <rect x="4" y="4" width="16" height="16" />
      <path d="M8 13l5-5" strokeWidth={1.5} />
      <path d="M9 17l8-8" strokeWidth={1.5} />
    </svg>
  );
}
